module.exports = __webpack_public_path__ + "static/media/Andrea.d87eaf46.jpg";